module.exports = __webpack_public_path__ + "zilla-slab-latin-600.861f6710725907ef44ee9b0d5d95874e.woff2";